import { _useContext } from "~/composables/shop/_useContext";

export default function (context = null) {
  const _context = _useContext("trackingContext", { context });
  return computed(() => _context.value);
}
